import React from "react";
import "./detailsCard.css";

const DetailsCard = ({ details }) => {
  return (
    <div className="detailsCard">
      {details.map((item, index) => (
        <div key={index} className="detailItem">
          <p className="detailHeading">{item.heading}</p>
          <p className="detailData">{item.data}</p>
        </div>
      ))}
    </div>
  );
};

export default DetailsCard;
